import createImmutableSelector from 'lib/immutable/selector'
import { ILayoutData } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getLayoutData = (state: any): ILayoutData => state.get('layoutDataReducer')

export const layoutDataSelector = createImmutableSelector(getLayoutData, (layoutData) => layoutData)
